/* unplugin-vue-components disabled */import script from "./headTabbar.vue?vue&type=script&setup=true&lang=js"
export * from "./headTabbar.vue?vue&type=script&setup=true&lang=js"

import "./headTabbar.vue?vue&type=style&index=0&id=00730e7e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00730e7e"]])

export default __exports__